<template>
  <div class="index container">
    <transition name="fade">
      <router-view @showParent="showParent"> </router-view>
    </transition>

    <div v-if="showParentPage">
      <v-breadcrumbs>
        <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
          >Home</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item
          :exact="true"
          :to="{ name: 'companyVehicle', params: {} }"
          active
        >
          Company Vehicle
        </v-breadcrumbs-item>
      </v-breadcrumbs>

      <div class="d-flex flex-column flex-lg-row">
        <v-text-field
          dense
          v-model="searchTerms"
          @keyup.enter="search"
          @click:clear="clearSearch"
          @click:append="search"
          placeholder="Press enter to begin search"
          append-icon="mdi-magnify"
          outlined
          clearable
          label="Search"
        />
        <v-btn
          class="ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start"
          color="primary"
          :to="{ name: 'companyVehicleCreate', params: {} }"
        >
          Create Company Vehicle
        </v-btn>
      </div>

      <div class="table-container">
        <v-data-table
          :headers="headers"
          :items="companyVehicleList"
          :items-per-page="pagination.pageSize"
          :loading="!companyVehicleProcessed"
          :server-items-length="pagination.totalSize"
          :page="pagination.current"
          :disable-pagination="
            !companyVehicleList || companyVehicleList.length < 1
          "
          :hide-default-header="
            !companyVehicleList || companyVehicleList.length < 1
          "
          :hide-default-footer="
            !companyVehicleList || companyVehicleList.length < 1
          "
          :options.sync="options"
          item-key="id"
          class="elevation-1"
          @update:options="pageChanged"
        >
          <template v-slot:item.vehicleLicensePlate="{ item }">
            <a @click="view(item)">{{ item.vehicleLicensePlate }}</a>
          </template>

          <template v-slot:item.vehicleType="{ item }">
            <a @click="view(item)">{{ item.vehicleType }}</a>
          </template>

          <template v-slot:item.vehicleNotes="{ item }">
            <a @click="view(item)">{{ item.vehicleNotes }}</a>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="edit(item)"> mdi-pencil </v-icon>
            <v-icon small class="mr-2" @click="remove(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </div>
    </div>
    <confirmation-dialog ref="confirm" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100,
      },
      companyVehicleList: [],
      showParentPage: true,
      options: {},
      headers: [
        {
          text: "License Plate",
          value: "vehicleLicensePlate",
          align: "start",
          sortable: true,
        },
        {
          text: "Type",
          value: "vehicleType",
          align: "start",
          sortable: true,
        },
        {
          text: "Company",
          value: "companyName",
          align: "start",
          sortable: true,
        },
        {
          text: "Notes",
          value: "vehicleNotes",
          align: "start",
          sortable: false,
        },

        { text: "Actions", value: "actions", align: "end", sortable: false },
      ],
      sort: {
        key: null,
      },
      searchTerms: "",
    };
  },
  computed: {
    ...mapGetters("companyVehicle", [
      "companyVehicleProcessed",
      "getCompanyVehicles",
    ]),
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),
    ...mapActions("companyVehicle", [
      "deleteCompanyVehicle",
      "fetchCompanyVehicles",
    ]),
    view(item) {
      this.$router.push({
        name: "companyVehicleView",
        params: { id: item.id },
      });
    },
    edit(item) {
      this.$router.push({
        name: "companyVehicleEdit",
        params: { id: item.id },
      });
    },
    async remove(item) {
      let confirm = await this.$refs.confirm.open(
        "Confirm Delete",
        "Do you want to delete this vehicle?"
      );
      if (confirm) {
        this.deleteCompanyVehicle(item.id)
          .then(() => {
            this.addSuccessMessage("vehicle was deleted successfully");
            this.getResources();
          })
          .catch(() => {
            this.addErrorMessage("Server response with error ");
          });
      }
    },
    getResources() {
      let sortBy =
        this.options["sortBy"] && this.options["sortBy"].length > 0
          ? this.options.sortBy[0]
          : "createTime";
      if (sortBy == "productName") {
        sortBy = "product.name";
      }
      if (sortBy == "processTypeName") {
        sortBy = "processType.name";
      }

      const sortDesc =
        this.options["sortDesc"] && this.options["sortDesc"].length > 0
          ? this.options.sortDesc[0]
          : true;

      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
        size: this.pagination.pageSize,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
      };
      if (this.searchTerms) {
        params["vehicleLicensePlate"] = this.searchTerms;
        params["vehicleNotes"] = this.searchTerms;
        params["company.name"] = this.searchTerms;
      }
      this.fetchCompanyVehicles(params)
        .then((response) => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.companyVehicleList = response.content;
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    showParent(show) {
      this.showParentPage = show;
    },
    pageChanged(pagination) {
      this.pagination.pageIndex = pagination.page;
      this.pagination.pageSize = pagination.itemsPerPage;

      this.getResources();
    },
    search() {
      this.getResources();
    },
    clearSearch() {
      this.searchTerms = null;
      this.getResources();
    },
  },
  watch: {
    "pagination.numberRegisterForPage": function () {
      this.pagination.current = -1;
    },
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.showParentPage = toDepth < fromDepth;
    if (this.showParentPage) {
      this.getResources();
    }
    next();
  },
};
</script>
